const firstUp = (word) =>
  word !== '' && word !== undefined && word !== '-'
    ? word.charAt(0).toUpperCase() + word.slice(1)
    : '';

export default firstUp;
